export default function (value, padding) {
  if(padding === undefined) padding = '00'
  return String(padding + value).slice(-padding.length);
}